import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDash } from "@fortawesome/pro-regular-svg-icons";
import { useEffect, useState } from "react";
import DateSelector from "./selector/DateSelector";

import "./DateRange.scss";
import { useTranslation } from "react-i18next";

interface IProps {
    start: Date;
    end: Date;
    onChange?: (start: Date, end: Date) => void;
}

export default function DateRange(props: IProps) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const { t } = useTranslation();

    const clampToToday = (date: Date) => {
        return date > today ? today : date;
    };

    const normalizeRange = (start: Date, end: Date) => {
        const s = clampToToday(start);
        const e = clampToToday(end);
        if (s > e) {
            return { start: e, end: s };
        }
        return { start: s, end: e };
    };

    const [date, setDate] = useState<{ start: Date; end: Date }>(normalizeRange(props.start, props.end));

    const updateRange = (newStart: Date, newEnd: Date) => {
        const normalized = normalizeRange(newStart, newEnd);
        setDate(normalized);
        props.onChange?.(normalized.start, normalized.end);
    };

    const onStartDateChange = (start: Date) => {
        updateRange(start, date.end);
    };

    const onEndDateChange = (end: Date) => {
        updateRange(date.start, end);
    };

    useEffect(() => {
        setDate(normalizeRange(props.start, props.end));
    }, [props.start, props.end]);

    return (
        <div className="userful-date-range-component">
            <h1>{t("Shared.dateRange")}</h1>
            <DateSelector date={date.start} onChange={onStartDateChange} />
            <FontAwesomeIcon icon={faDash} />
            <DateSelector date={date.end} onChange={onEndDateChange} />
        </div>
    );
}
